import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import CommonMenu, { MENU_ITEM_TYPES } from '../../../../components/common-menu/CommonMenu';
import { ICONS } from '../../../../icons';
import Icon from '../../../../icons/Icon';
import { PROJECT_TYPES, USER_ROLES } from '../../../../constants';

const ProjectActionsPopper = ({
  onShare,
  onEdit,
  onDelete,
  onDeactivate,
  onCollectData,
  isActive,
  isShareActive,
  projectType,
}) => {
  const { t } = useTranslation('projects');
  const userStatus = useSelector((state) => state.securityNew.userStatus);

  const PROJECTS_MENU_OPTIONS = useMemo(() => {
    return [
      ...(isShareActive
        ? [
            {
              label: t('share'),
              type: MENU_ITEM_TYPES.LABEL,
              value: onShare,
              icon: <Icon icon={ICONS.Share} disableCommonStyles disableCommonColors />,
            },
          ]
        : []),
      {
        label: isActive ? t('deactivate') : t('activate'),
        type: MENU_ITEM_TYPES.LABEL,
        value: onDeactivate,
        icon: <Icon icon={isActive ? ICONS.EyeCrossed : ICONS.Eye} disableCommonStyles disableCommonColors />,
        isStrokeIcon: true,
      },
      ...(projectType === PROJECT_TYPES.SONAR
        ? [
            {
              label: t('collectData'),
              type: MENU_ITEM_TYPES.LABEL,
              value: onCollectData,
              icon: <Icon icon={ICONS.Unclust} disableCommonStyles disableCommonColors />,
            },
          ]
        : []),
      {
        label: t('edit'),
        type: MENU_ITEM_TYPES.LABEL,
        value: onEdit,
        icon: <Icon icon={ICONS.Edit} disableCommonStyles disableCommonColors />,
      },
      {
        label: t('delete'),
        type: MENU_ITEM_TYPES.LABEL,
        value: onDelete,
        icon: <Icon icon={ICONS.Delete} disableCommonStyles disableCommonColors />,
      },
    ];
  }, [t, onShare, onEdit, onDelete, onDeactivate, onCollectData, projectType, isActive, isShareActive]);

  //!TEMPORARY ACCESS TO COLLECT DATA
  const TEMP_SONAR_MENU_OPTIONS = useMemo(() => {
    return [
      ...(isShareActive && userStatus.includes(USER_ROLES.GLOBAL_ADMIN)
        ? [
            {
              label: t('share'),
              type: MENU_ITEM_TYPES.LABEL,
              value: onShare,
              icon: <Icon icon={ICONS.Share} disableCommonStyles disableCommonColors />,
            },
          ]
        : []),
      ...(userStatus.includes(USER_ROLES.GLOBAL_ADMIN)
        ? [
            {
              label: isActive ? t('deactivate') : t('activate'),
              type: MENU_ITEM_TYPES.LABEL,
              value: onDeactivate,
              icon: <Icon icon={isActive ? ICONS.EyeCrossed : ICONS.Eye} disableCommonStyles disableCommonColors />,
              isStrokeIcon: true,
            },
          ]
        : []),
      {
        label: t('collectData'),
        type: MENU_ITEM_TYPES.LABEL,
        value: onCollectData,
        icon: <Icon icon={ICONS.Unclust} disableCommonStyles disableCommonColors />,
      },
      ...(userStatus.includes(USER_ROLES.GLOBAL_ADMIN)
        ? [
            {
              label: t('edit'),
              type: MENU_ITEM_TYPES.LABEL,
              value: onEdit,
              icon: <Icon icon={ICONS.Edit} disableCommonStyles disableCommonColors />,
            },
          ]
        : []),
      ...(userStatus.includes(USER_ROLES.GLOBAL_ADMIN)
        ? [
            {
              label: t('delete'),
              type: MENU_ITEM_TYPES.LABEL,
              value: onDelete,
              icon: <Icon icon={ICONS.Delete} disableCommonStyles disableCommonColors />,
            },
          ]
        : []),
    ];
  }, [t, onShare, onEdit, onDelete, onDeactivate, onCollectData, isActive, isShareActive, userStatus]);

  const handleSelect = useCallback((selectedItem) => {
    selectedItem.value();
  }, []);

  return (
    <CommonMenu
      options={projectType === PROJECT_TYPES.SONAR ? TEMP_SONAR_MENU_OPTIONS : PROJECTS_MENU_OPTIONS}
      onSelect={handleSelect}
    />
  );
};

export default ProjectActionsPopper;
